<template>
  <div class="edition-details container main-container">
    <div class="title">Volume {{volumeNumber}} Number {{numberNumber}} {{title}}</div>
    <div class="edition-links"><a :href="pagesUrl" target="_blank" v-if="pagesUrl">Full Page Version</a> <a :href="spreadsUrl" target="_blank" v-if="spreadsUrl">Spread Page Version</a></div>
    <div class="toc" v-if="tocUrl"><a :href="tocUrl" target="_blank">Table of Contents</a></div>
    <EditionSection v-for="section in sections" :section="section" :key="section.order" />
  </div>
</template>

<script>
import JournalData from '../helpers/journaldata'
import EditionSection from '@/components/EditionSection.vue'

export default {
  name: 'EditionDetails',
  props: ['volume', 'number'],
  components: {
    EditionSection
  },
  data () {
    return {
      journalData: JournalData
    }
  },
  computed: {
    volumeNumber () {
      return this.volume ? parseInt(this.volume) : 0
    },
    numberNumber () {
      return this.number ? parseInt(this.number) : 0
    },
    edition () {
      return this.journalData.editions.filter((ed) => this.volumeNumber === ed.volume && this.numberNumber === ed.number)[0]
    },
    title () {
      return this.edition ? this.edition.title : null
    },
    spreadsUrl () {
      return this.edition ? this.edition.spreads : null
    },
    pagesUrl () {
      return this.edition ? this.edition.fullPage : null
    },
    tocUrl () {
      return this.edition ? this.edition.toc : null
    },
    sections () {
      return this.edition && this.edition.sections ? this.edition.sections.filter(() => true).sort((s1, s2) => s1.order - s2.order) : []
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 32px;
  font-weight: 700;
}
.toc {
  font-size: 26px;
  font-weight: 600;
  padding-top: 15px;
  & a {
    text-decoration: none;
  }
}
.edition-links {
  font-size: 20px;
  padding-top: 15px;
  & a {
    padding-right: 10px;
  }
}
</style>
